import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/rappers', { params })
  },
  store (formData) {
    return apiClient.post('/rappers', formData)
  },
  show (id, params) {
    return apiClient.get(`/rappers/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/rappers/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/rappers/${id}`)
  }
}
